import {api} from './api';
import {Condition, ConditionType} from '../../features/biotwin/types';
import {buildURLSearch} from '../utils/apiUtils';
import {MatchMode} from '../types';

export const conditionApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getConditions: builder.query<
      Condition[],
      {
        conditionTypeId?: number;
        includeGroups?: boolean;
        pageNumber: number;
        pageSize: number;
        searchTerm: string;
        searchTermMatchMode?: MatchMode;
        similarityThreshold?: number;
        userId: number;
      }
    >({
      query: (arg) => `/conditions${buildURLSearch(arg)}`,
    }),

    getConditionsDataCount: builder.query<
      number,
      {
        conditionTypeId?: number;
        includeGroups?: boolean;
        searchTerm: string;
        searchTermMatchMode: MatchMode;
        similarityThreshold?: number;
        userId: number;
      }
    >({
      query: (arg) => ({
        url: `/conditions${buildURLSearch(arg)}`,
        method: 'HEAD',
      }),
      transformResponse: (_response, meta) => {
        return +(meta?.response?.headers.get('data-count') ?? 0);
      },
    }),

    getSubConditions: builder.query<Condition[], {parentConditionId: number}>({
      query: ({parentConditionId}) => `/conditions/${parentConditionId}/sub`,
    }),

    getConditionTypes: builder.query<ConditionType[], void>({
      query: () => `/condition-types`,
    }),
  }),
});

export const {
  useGetConditionsQuery,
  useLazyGetConditionsQuery,
  useLazyGetConditionsDataCountQuery,
  useLazyGetSubConditionsQuery,

  useGetConditionTypesQuery,
} = conditionApi;
